<template>
  <div v-if="received">
    <div class="md-layout md-gutter">
      <div class="md-layout-item md-size-50 md-small-size-100 mb-1" v-if="!payg">
        <md-field>
          <label>Suggested document quota</label>
          <md-input required v-model="internalMetadata.quota" @input="syncMetadata" />
          <span class="md-helper-text">
            This value does not reflect on past subscriptions.
          </span>
        </md-field>
      </div>
      <div class="md-layout-item md-size-50 md-small-size-100 mb-1" v-if="!payg">
        <md-field>
          <label class="required">Document quota renews each</label>
          <md-select v-model="internalMetadata.quotaRenewal" @input="syncMetadata">
            <md-option value="month">Month</md-option>
            <md-option value="year">Year</md-option>
          </md-select>
        </md-field>
      </div>
    </div>

    <div class="md-layout md-gutter">
      <div class="md-layout-item md-size-50 md-size-small-100 mb-1">
        <md-field>
          <label>Suggested SMS price per unit</label>
          <MoneyInput
          required
          @valueChange="smsValueChange"
          name="smsUnitAmount"
          v-bind:initialValue="internalMetadata.smsUnitAmount"
          />
          <span class="md-helper-text">
            This value does not reflect on past subscriptions.
          </span>
        </md-field>
      </div>
      <div class="md-layout-item md-size-50 md-small-size-100 mb-1" v-if="!payg">
        <md-field>
          <label>Suggested document price per unit</label>
          <MoneyInput
          required
          @valueChange="documentValueChange"
          name="overageUnitAmount"
          v-bind:initialValue="internalMetadata.overageUnitAmount"
          />
          <span class="md-helper-text">
            This value does not reflect on past subscriptions.
          </span>
        </md-field>
      </div>
    </div>

    <div class="md-layout md-gutter">
      <div class="md-layout-item md-size-100 mb-1">
        <md-field>
          <label class="required">User suggested level</label>
          <md-select v-model="internalMetadata.kind" @input="syncMetadata">
            <md-option v-for="kind in kinds" v-bind:key="kind[0]" :value="kind[0]">
              {{ kind[1] }}
            </md-option>
          </md-select>
        </md-field>
      </div>
    </div>
  </div>
</template>
<script type="ts">
import Vue from 'vue';
import BillingPriceMetadata from '@/datatypes/billing/price-metadata';
import MoneyInput from '@/components/money.vue';
import User from '@/datatypes/user';

export default Vue.extend({
  name: 'billing-metadata',
  props: [
    'metadata',
    'payg',
  ],
  components: {
    MoneyInput,
  },
  data: () => ({
    internalMetadata: new BillingPriceMetadata({}),
    received: false,
    user: new User({}),
  }),
  mounted() {
    this.receivedMetadata();
  },
  methods: {
    documentValueChange($event) {
      this.internalMetadata.overageUnitAmount = $event;
      this.syncMetadata();
    },
    smsValueChange($event) {
      this.internalMetadata.smsUnitAmount = $event;
      this.syncMetadata();
    },
    receivedMetadata() {
      this.internalMetadata = new BillingPriceMetadata(this.metadata || {});
      this.received = true;
    },
    syncMetadata() {
      this.$emit('update:metadata', this.internalMetadata);
    },
  },
  computed: {
    kinds() {
      return this.user.kindHash.filter(
        (item) => item.subscription === true,
      ).map(
        (item) => [item.kind, item.name],
      );
    },
  },
});
</script>
